import MaintenancePage from "../MaintenancePage";
import resource from "../../resources/signatoryResource";

export default function Signatories() {
    return <MaintenancePage resource={resource} />;
}
